import React from 'react';

import {
  showContentItemsExcept,
  hideContentItemsExcept,

  addContentItemFixedClass,
  removeContentItemFixedClass,

  replaceFullScreenIconWithMinimizeIcon,
  replaceMinimizeIconsWithFullScreenIcons
} from './utils';

const FullScreenableContainer = WrappedComponent => {
  class HigherOrderComponent extends React.Component {
    constructor (props) {
      super(props);

      this.state = {
        inFullScreenMode: false,
        contentItemElement: null
      };

      this.captureContentItemElement = elt =>
        this.setState({ contentItemElement: elt });

      this.handleFullScreenIconClick = () => {
        const {
          inFullScreenMode,
          contentItemElement
        } = this.state;

        if (inFullScreenMode) {
          showContentItemsExcept(contentItemElement);
          replaceMinimizeIconsWithFullScreenIcons();
          removeContentItemFixedClass();
        } else {
          replaceFullScreenIconWithMinimizeIcon(contentItemElement);
          addContentItemFixedClass(contentItemElement);
          hideContentItemsExcept(contentItemElement);
        }

        this.setState(state => ({ inFullScreenMode: !state.inFullScreenMode }));
      };
    }

    render () {
      return (
        <WrappedComponent
          {...this.props}

          onFullScreenIconClick={this.handleFullScreenIconClick}
          captureContentItemElement={this.captureContentItemElement}
        />
      );
    }
  }

  return HigherOrderComponent;
};

export default FullScreenableContainer;
